"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateEmployeeSchema = exports.createEmployeeSchema = exports.employeeNameSchema = void 0;
const zod_1 = require("zod");
const common_1 = require("./common");
const system_profiles_1 = require("../constants/system-profiles");
exports.employeeNameSchema = zod_1.z.object({
    prefix: zod_1.z.enum(['', 'Mr.', 'Mrs.', 'Ms.']).optional(),
    firstName: zod_1.z.string().min(1).trim(),
    lastName: zod_1.z.string().min(1).trim(),
    suffix: zod_1.z.string().optional(),
});
// `password` deliberately absent — admins never set or change passwords via
// the Employee form. New users receive a portal-invitation email with a
// password-setup link; existing users update their own password on the
// Profile page (`/auth/me/change-password`). Removing the field from the
// schema means even a hand-crafted POST can't sneak a password through
// the admin path.
exports.createEmployeeSchema = zod_1.z.object({
    name: exports.employeeNameSchema,
    email: zod_1.z.string().email().nullable().optional(),
    mobile: zod_1.z.string().nullable().optional(),
    branches: zod_1.z.array(common_1.objectIdSchema).optional(),
    rolePermission: common_1.objectIdSchema.nullable().optional(),
    department: common_1.objectIdSchema.nullable().optional(),
    systemProfile: zod_1.z.enum(system_profiles_1.SYSTEM_PROFILES).optional(),
    hourlyRate: zod_1.z.number().min(0).optional(),
    serviceLocation: common_1.objectIdSchema.nullable().optional(),
    createPortalLogin: zod_1.z.boolean().optional(),
    jobcardNotificationEmail: zod_1.z.boolean().optional(),
    emailTipperFleetRunSheet: zod_1.z.boolean().optional(),
});
exports.updateEmployeeSchema = exports.createEmployeeSchema.partial().extend({
    status: zod_1.z.enum(['Active', 'Archived']).optional(),
});
//# sourceMappingURL=employee.js.map